import { render, staticRenderFns } from "./table_list.vue?vue&type=template&id=ef870682&scoped=true&"
import script from "./table_list.vue?vue&type=script&lang=js&"
export * from "./table_list.vue?vue&type=script&lang=js&"
import style0 from "./table_list.vue?vue&type=style&index=0&id=ef870682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef870682",
  null
  
)

export default component.exports